<template>
  <div type="card-full" v-loading="loading">
        <div class="head-title">项目评审表</div>
        <div class="line1"></div>
        <div>
          <div class="view-container">
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">项目编号</div>
                        <div class="view-value">{{project.projectcode}}</div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">项目名称</div>
                        <div class="view-content">{{project.projectname}}</div>
                    </div>
                </div>
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">采购人</div>
                        <div class="view-value">{{project.pcomfullname}}</div>
                    </div>
                    <div class="view-field" v-if="+project.projecttype === 1">
                        <div class="view-label">代理人</div>
                        <div class="view-value">{{project.acomfullname}}</div>
                    </div>
                </div>
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">评审开始时间</div>
                        <div class="view-value" v-if="pexertList.length>0">{{pexertList[0].pexpertlogintime |newDateTime}}</div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">评审截止时间</div>
                        <div class="view-value">{{prs.pstime | newDateTime}}</div>
                    </div>
                </div>
                <div id="countersignResult">
                  <div class="countersignResult">
                    <div class="countersignResultHeader">
                        <div class="countersignResultHeader-item L-W">供应商</div>
                        <div class="countersignResultHeader-item">评审分</div>
                        <div class="countersignResultHeader-item">价格得分</div>
                        <div class="countersignResultHeader-item" v-if="+project.projectdoneflg === 5">履约得分</div>
                        <div class="countersignResultHeader-item">最终得分</div>
                        <div class="countersignResultHeader-item">排名</div>
                    </div>
                    <div class="countersignResultBody" v-for="item in list" :key="item.psid">
                        <div class="countersignResultHeader-item L-W">{{item.comfullname}}</div>
                        <div class="countersignResultHeader-item">{{item.pscommercialasexchange}}</div>
                        <div class="countersignResultHeader-item">{{item.psppriceasexchange}}</div>
                        <div class="countersignResultHeader-item" v-if="+project.projectdoneflg === 5">{{ item.psperformanceas}}</div>
                        <div class="countersignResultHeader-item">{{item.psas}}</div>
                        <div class="countersignResultHeader-item">{{item.psseq}}</div>
                    </div>
                  </div>
                </div>
                <div class="prxertWrite" style="padding-top:30px;padding-bottom:30px;">
                  专家签名：
                  <!-- <div class="countersignResult">
                    <div class="countersignResultHeader">
                        <div class="countersignResultHeader-item">姓名</div>
                        <div class="countersignResultHeader-item">签名</div>
                    </div>
                    <div v-for="item in pexertList" :key="item.pexpertid">
                        <div class="countersignResultBody">
                          <div class="countersignResultHeader-item">{{item.pexpertname}}</div>
                          <div class="countersignResultHeader-item">  </div>
                        </div>
                        <div class="countersignResultBody">
                          <div class="countersignResultHeader-item"></div>
                          <div class="countersignResultHeader-item"></div>
                        </div>
                    </div>
                  </div> -->
                </div>
            </div>
          </div>
        </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: 'projectMeetingP',
    filters: {
    },
    computed:{
    },
    data () {
      return {
          loading:false,
          project:{},
          pexertList:[],
          prs:{},
          list:[]
      }
    },
    created () {
        this.getModel()
        this.getPageList()
    },
    filters:{
      
      newDateTime (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      }
    },
    activated () {
    },
    components: {},
    mounted () {
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/getMettingListP',
          params: {projectid: this.$route.query.projectid}
        })
        this.project = res.projectList
        this.prs = res.prsList
        this.pexertList = res.pexertList
      },
      async getPageList () {
          this.loading = true
          let res = await request({
              method: 'get',
              url: 'expert/getMeetingList',
              params: {projectid: this.$route.query.projectid}
          })
          this.list = res
          this.loading = false
      },
    }
  }
</script>
<style lang="scss" scoped>

.line1 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #000;
  margin:20px 0;
  background: #000;
}
.head-title {
  font-weight: bold;
  font-size: 26px;
  color: #000;
  margin-top: 20px;
  word-wrap: break-word;
  font-weight: bold;
  text-align: center;
  span {
    font-size: 14px;
  }
}
.bjview-box{
  border-top: 1px solid  #000;
  border-left: 1px solid  #000;
  border-right: 1px solid  #000;
}
.bjview-header{
  display:flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}
.bjview-index{
  text-align: center;
  width: 50px;
  border-bottom: 1px solid  #000;
  border-right: 1px solid  #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bjview-item{
  display: flex;
  line-height: 35px;
}
.view-container{
  font-size: 16px;
}
.view-container .view-box .view-row .view-field .view-value,.view-container .view-box .view-row .view-field .view-content{
  color: #000;
}
.bjview-name{
  overflow: hidden;
  width: 200px;

  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid  #000;
  border-right: 1px solid  #000;
  
  display: flex;
  justify-content: center;
  align-items: center;
}
.bjview-name-t{
  overflow: hidden;
  width: 200px;

  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid  #000;
  border-right: 1px solid  #000;
  
  display: flex;
  justify-content: center;
  align-items: center;
}
.bjview-name-j{
  overflow: hidden;
  width: 200px;
  border-bottom: 1px solid  #000;
  
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child{
  border-right: none;
}
.header-jl{
    border-bottom: 1px solid  #000;
}
.header-jl-r{
    border-right: 1px solid  #000;
}
.bjview-list{
  flex: 5;
  -webkit-box-flex: 5;
  justify-content: space-around;
  box-sizing: border-box;
  border-right: 1px solid  #000;
  border-bottom: 1px solid  #000;
  overflow: hidden;
}
.bjview-list-r{
  width: 200px;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #000000;
  border-bottom: 1px solid #000000;
  overflow: hidden;
}
.bjview-list-item{
    display: flex;
    padding-left: 10px;
    white-space:nowrap;
    border-bottom: 1px solid  #000;
}
.bjview-list-item:last-child{
  
    height:100%;
}
.item-index{
  // width: 150px;
  flex:2;
  -webkit-box-flex: 1;
  border-right: 1px solid  #000;
  text-align: center;
}
.item-price{
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}
.bjview-button{
  width: 100%;
  display:flex;
  justify-content: center;
}
.button-i{
  margin: 30px 0 auto;
  width: 200px;
}
.bjview-red{
  color:red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}



.countersignResult{
  background-color: #fff;
  width: 100%;
  margin: 0 auto;
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  text-align: center;
}
.countersignResultHeader{
  background-color: #f8f8f9;
  display: flex;
  justify-content: center;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e8eaec;
}
.countersignResultHeader-item{
  flex:1;
  height: 60px;
  line-height: 60px;
  border-right: 1px solid #e8eaec;
}
.countersignResultHeader-item:last-child{
  border: none;
}
.L-W{
  flex: 3;
}
.countersignResultBody{
  display: flex;
  justify-content: center;
  line-height: 48px;
  border-bottom: 1px solid #e8eaec;
}


</style>
